import { render, staticRenderFns } from "./SubmissionAccordion.vue?vue&type=template&id=0476e32b&scoped=true&"
import script from "./SubmissionAccordion.vue?vue&type=script&lang=js&"
export * from "./SubmissionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionAccordion.vue?vue&type=style&index=0&id=0476e32b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476e32b",
  null
  
)

export default component.exports